import {
  WorkOrderServiceCategory,
  WorkOrderServiceItem,
} from '@backoffice-frontend/graphql'
import { Option } from '@moia-dev/pace-web'
import {
  useWorkOrderServiceCategoryTranslation,
  useWorkOrderServiceItemTranslation,
} from '../hooks/useWorkOrderTranslations'

export type WorkOrderServiceItemCategoryMapping = {
  title: WorkOrderServiceCategory
  serviceItems: WorkOrderServiceItem[]
}

const workOrderServiceItemCategoryMappings: WorkOrderServiceItemCategoryMapping[] =
  [
    {
      title: WorkOrderServiceCategory.HubActivities,
      serviceItems: [
        WorkOrderServiceItem.OutsideCleaning,
        WorkOrderServiceItem.InsideCleaning,
        WorkOrderServiceItem.DemoCleaning,
        WorkOrderServiceItem.Charging,
        WorkOrderServiceItem.VehicleLettering,
        WorkOrderServiceItem.TransferRide,
        WorkOrderServiceItem.SparePartsRequest,
        WorkOrderServiceItem.TabletUpdate,
      ],
    },
    {
      title: WorkOrderServiceCategory.Incident,
      serviceItems: [
        WorkOrderServiceItem.InFieldSupport,
        WorkOrderServiceItem.OnSiteTireChange,
      ],
    },
    {
      title: WorkOrderServiceCategory.MaintenanceService,
      serviceItems: [
        WorkOrderServiceItem.BrakeFluidChange,
        WorkOrderServiceItem.MainInspection,
        WorkOrderServiceItem.MileageInspection,
        WorkOrderServiceItem.Maintenance,
        WorkOrderServiceItem.InternalInspection,
      ],
    },
    {
      title: WorkOrderServiceCategory.DamagesDefects,
      serviceItems: [
        WorkOrderServiceItem.SeatComplaint,
        WorkOrderServiceItem.SmartRepairDent,
        WorkOrderServiceItem.SmartRepairPaintwork,
      ],
    },
    {
      title: WorkOrderServiceCategory.Other,
      serviceItems: [WorkOrderServiceItem.Other],
    },
  ]

export const workOrderServiceItemOptions = () => {
  return workOrderServiceItemCategoryMappings.flatMap(category => [
    <Option key={category.title} disabled={true} value={''}>
      {useWorkOrderServiceCategoryTranslation()(category.title)}
    </Option>,
    ...category.serviceItems.map(item => (
      <Option key={item} value={item}>
        {useWorkOrderServiceItemTranslation()(item)}
      </Option>
    )),
  ])
}
